export const featureCards = [
    {
        title: 'Trimix Injections',
        description:
            'When you want immediate results or oral medications aren’t enough, try powerful Trimix injections.',
        link: '/trimix',
        image: '/images/card-feature-section/feature-1.png',
        backgroundClass: 'bg-[#d6d9e1] bg-no-repeat bg-bottom bg-contain custom-feature-bg1',
    },
    {
        title: 'Oral Medication',
        description:
            'The medications you know and love. Access Sildenafil (same ingredient as Viagra®), Tadalafil (same ingredient as Cialis®), and more.',
        link: '/oral-meds',
        image: '/images/card-feature-section/feature-2.png',
        backgroundClass: 'bg-[#f6f6ec] bg-no-repeat bg-bottom bg-contain custom-feature-bg2',
    },
];
